export enum AuthenticationMethod {
  UsernamePassword = 'UsernamePassword',
  BankIdQr = 'BankIdQr',
  BankId = 'BankId'
}
